import type { PocTableRowCustomEvent } from 'commons/types';
import { CustomTableComponent, CustomTableConfig } from 'commons/components';
import { CustomTableSortItems } from 'commons/components/table/sort/custom-table-sorting.model';
import { MaterialDefinition } from '../material-definition.vm';

export interface SettingsMaterialDefinitionsListComponentProps {
    title: string;
    emptyMessage: string;
    materials: MaterialDefinition[];
    isLoading: boolean;
    config: CustomTableConfig<MaterialDefinition>;
    scrollContainerRef?: React.RefObject<HTMLDivElement>;
    defaultSort?: CustomTableSortItems;
    selectedRowIds?: Set<string>;
    setSelectedRowIds?: React.Dispatch<React.SetStateAction<Set<string>>>;
    onSortOrderChange?: (sortItems: CustomTableSortItems) => void;
    onSelectRow?: (id: string, selected: boolean) => void;
    onRowClick?: (id: string) => void;
    rowOptions?: (data: MaterialDefinition) => React.ReactElement[];
}

export const SettingsMaterialDefinitionsListComponent: React.FC<SettingsMaterialDefinitionsListComponentProps> = ({
    title,
    emptyMessage,
    materials,
    isLoading,
    config,
    scrollContainerRef,
    defaultSort,
    selectedRowIds,
    setSelectedRowIds,
    onSortOrderChange,
    onSelectRow,
    onRowClick,
    rowOptions,
}) => (
    <CustomTableComponent<MaterialDefinition>
        headerTitle={title}
        loading={isLoading}
        totalElements={materials.length}
        tableData={materials}
        config={config}
        scrollContainerRef={scrollContainerRef}
        sortingProps={{ defaultSort, onSortOrderChange }}
        horizontalScroll
        emptyMessage={emptyMessage}
        showSelectionColumn
        selectedRowIds={selectedRowIds}
        setSelectedRowIds={setSelectedRowIds}
        onSelectRow={
            onSelectRow
                ? (id: string, event: PocTableRowCustomEvent<boolean>) => onSelectRow(id, event.detail)
                : undefined
        }
        onClickRow={onRowClick}
        rowOptions={rowOptions}
    />
);
